import React from "react";

const LoginIcon = props => (
  <svg
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="20"
    fill="none"
    viewBox="0 0 17 20"
  >
    <g
      stroke={props.color}
      strokeLinecap="round"
      strokeMiterlimit="10"
      clipPath="url(#clip0)"
    >
      <path
        strokeLinejoin="round"
        d="M15.625 18.125c0 .688-.563 1.25-1.25 1.25h-12.5c-.688 0-1.25-.563-1.25-1.25V8.75c0-.688.563-1.25 1.25-1.25h12.5c.688 0 1.25.563 1.25 1.25v9.375z"
      ></path>
      <path d="M8.125 12.5a.625.625 0 100-1.25.625.625 0 000 1.25z"></path>
      <path d="M8.125 12.5V15"></path>
      <path
        strokeLinejoin="round"
        d="M3.75 7.5V5a4.376 4.376 0 018.75 0v2.181"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0H16.25V20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default LoginIcon;



// WEBPACK FOOTER //
// ./src/icons/LoginIcon.jsx